module.exports = __webpack_public_path__ + "img/platinum-card.b8623f87.png";